export const ASSET_LIST = "ASSET_LIST";
export const ASSET_LIST_SUCCESS = "ASSET_LIST_SUCCESS";
export const ASSET_LIST_FAILURE = "ASSET_LIST_FAILURE";

export const ASSET_DATA = "ASSET_DATA";
export const ASSET_DATA_SUCCESS = "ASSET_DATA_SUCCESS";
export const ASSET_DATA_FAILURE = "ASSET_DATA_FAILURE";

export const ASSET_CREATE = "ASSET_CREATE";
export const ASSET_CREATE_SUCCESS = "ASSET_CREATE_SUCCESS";
export const ASSET_CREATE_FAILURE = "ASSET_CREATE_FAILURE";

export const ASSET_UPDATE = "ASSET_UPDATE";
export const ASSET_UPDATE_SUCCESS = "ASSET_UPDATE_SUCCESS";
export const ASSET_UPDATE_FAILURE = "ASSET_UPDATE_FAILURE";

export const ASSET_DELETE = "ASSET_DELETE";
export const ASSET_DELETE_SUCCESS = "ASSET_DELETE_SUCCESS";
export const ASSET_DELETE_FAILURE = "ASSET_DELETE_FAILURE";

// Bulk reclassification from the asset list (Task 24439)
export const ASSET_BULK_ASSIGN = "ASSET_BULK_ASSIGN";
export const ASSET_BULK_ASSIGN_SUCCESS = "ASSET_BULK_ASSIGN_SUCCESS";
export const ASSET_BULK_ASSIGN_FAILURE = "ASSET_BULK_ASSIGN_FAILURE";

// Asset notes (Task 24447)
export const ASSET_NOTE_LIST = "ASSET_NOTE_LIST";
export const ASSET_NOTE_LIST_SUCCESS = "ASSET_NOTE_LIST_SUCCESS";
export const ASSET_NOTE_LIST_FAILURE = "ASSET_NOTE_LIST_FAILURE";

export const ASSET_NOTE_CREATE = "ASSET_NOTE_CREATE";
export const ASSET_NOTE_CREATE_SUCCESS = "ASSET_NOTE_CREATE_SUCCESS";
export const ASSET_NOTE_CREATE_FAILURE = "ASSET_NOTE_CREATE_FAILURE";

export const ASSET_NOTE_UPDATE = "ASSET_NOTE_UPDATE";
export const ASSET_NOTE_UPDATE_SUCCESS = "ASSET_NOTE_UPDATE_SUCCESS";
export const ASSET_NOTE_UPDATE_FAILURE = "ASSET_NOTE_UPDATE_FAILURE";

export const ASSET_NOTE_DELETE = "ASSET_NOTE_DELETE";
export const ASSET_NOTE_DELETE_SUCCESS = "ASSET_NOTE_DELETE_SUCCESS";
export const ASSET_NOTE_DELETE_FAILURE = "ASSET_NOTE_DELETE_FAILURE";

// Asset attachments (Task 24446) - upload goes through the shared
// uploadMultipleFiles / fileattachment flow, so only search + delete here.
export const ASSET_ATTACHMENT_SEARCH = "ASSET_ATTACHMENT_SEARCH";
export const ASSET_ATTACHMENT_SEARCH_SUCCESS = "ASSET_ATTACHMENT_SEARCH_SUCCESS";
export const ASSET_ATTACHMENT_SEARCH_FAILURE = "ASSET_ATTACHMENT_SEARCH_FAILURE";

export const ASSET_ATTACHMENT_DELETE = "ASSET_ATTACHMENT_DELETE";
export const ASSET_ATTACHMENT_DELETE_SUCCESS = "ASSET_ATTACHMENT_DELETE_SUCCESS";
export const ASSET_ATTACHMENT_DELETE_FAILURE = "ASSET_ATTACHMENT_DELETE_FAILURE";

// Asset recent activity (Tasks 24446/24447/24449)
export const ASSET_RECENT_ACTIVITY_LIST = "ASSET_RECENT_ACTIVITY_LIST";
export const ASSET_RECENT_ACTIVITY_LIST_SUCCESS = "ASSET_RECENT_ACTIVITY_LIST_SUCCESS";
export const ASSET_RECENT_ACTIVITY_LIST_FAILURE = "ASSET_RECENT_ACTIVITY_LIST_FAILURE";

// Field service bookings that reserve this asset (Task 24449)
export const ASSET_DIARY_SLOT_LIST = "ASSET_DIARY_SLOT_LIST";
export const ASSET_DIARY_SLOT_LIST_SUCCESS = "ASSET_DIARY_SLOT_LIST_SUCCESS";
export const ASSET_DIARY_SLOT_LIST_FAILURE = "ASSET_DIARY_SLOT_LIST_FAILURE";
